import { Component, Input, OnInit, inject } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

import { DocumentSearchCriteria, ExecutionResult, ITcmModel } from "@tylertech/tyler-api-types";

import { DocumentService } from "../../services";

@Component({
    selector: "tcm-viewer",
    templateUrl: "./tcmViewer.tmpl.html",
    styleUrls: [
        "./tcmViewer.component.scss"
    ],
    standalone: false
})
export class TcmViewerComponent implements OnInit
{
    private readonly domSanitizer = inject(DomSanitizer);
    private readonly $documentApiService = inject(DocumentService);

    @Input() private readonly docType?: string;
    @Input() private readonly entityId: string;
    @Input() private readonly entityType: string;
    @Input() private readonly tcmEntity: ITcmModel;

    protected promise?: Promise<void>;

    hasPermission: boolean;
    isLoaded: boolean;
    tcmUrl: SafeUrl;

    ngOnInit(): void
    {
        const criteria: DocumentSearchCriteria = {
            DocType: this.docType,
            EntityId: this.entityId,
            EntityType: this.entityType,
            Entity: this.tcmEntity,
        };

        this.promise = this.$documentApiService.GetTcm(criteria)
            .then((executionResult: ExecutionResult<string>) =>
            {
                const url = executionResult.Result;
                this.hasPermission = !!url;
                this.tcmUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);

                this.isLoaded = true;
            })
            .finally(() =>
            {
                this.promise = undefined;
            });
    }
}
